import React from 'react'
import { Person } from 'react-bootstrap-icons'

export default function EntityMetadataBox({
  avatarUrl,
  avatarAlt = 'Avatar',
  primaryLabel,
  primaryValue,
  secondaryLabel,
  secondaryValue,
}) {
  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter rounded-md flex items-center">
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={avatarAlt}
          className="w-8 h-8 rounded-full mx-2 object-cover flex-shrink-0"
        />
      ) : (
        <div className="w-8 h-8 rounded-full mx-2 bg-rb-green text-white flex items-center justify-center flex-shrink-0">
          <Person className="w-4 h-4" />
        </div>
      )}
      <div className="flex flex-col items-start justify-center px-3 border-r-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter">
        <p className="text-sm text-rb-lighter-grey dark:text-gray-400">{primaryLabel}</p>
        <p className="text-sm font-bold dark:text-white">{primaryValue || '—'}</p>
      </div>
      <div className="flex flex-col items-start justify-center px-3">
        <p className="text-sm text-rb-lighter-grey dark:text-gray-400">{secondaryLabel}</p>
        <p className="text-sm font-bold dark:text-white">{secondaryValue || '—'}</p>
      </div>
    </div>
  )
}
